module.exports = { apiServer: 'https://api.uat.in-store.hk', AdminServer: 'https://admin.Eventizer.hk' };
